import { useTracking } from 'react-tracking';

import { useAppContext } from '@contexts/AppContext';
import { EventProperties, fireEvent } from '@tracking';

export default function useEventTracking(
  properties: EventProperties = {},
  dispatchOnMount?: boolean
) {
  const { initialCurrentUser: currentUser } = useAppContext();
  properties.currentUser = currentUser;
  const { Track, trackEvent, getTrackingData } = useTracking(properties, {
    dispatch: fireEvent,
    dispatchOnMount,
  });
  return { Track, trackEvent, getTrackingData };
}
